const EventBus_Enum = {
  // 更新购物车角标
  UPDATE_CART_COUNT: 'update_cart_count',
  // 更新整个页面dom，window.location.reload 过于粗暴
  FULL_LAYOUT_RELOAD: 'full_layout_reload',
  // 搜索部分
  SEARCH_DATA_PART: 'search_data_part',
  SEARCH_FORM_PART: 'search_form_part',
};

class EventBus {
  events = {};
  type = EventBus_Enum;

  constructor() {
    this.events = this.events;
    this.type = this.type;
  }

  emit(type, ...args) {
    let e;
    e = this.events[type];
    if (Array.isArray(e)) {
      for (let i = 0; i < e.length; i++) {
        e[i].apply(this, args);
      }
    } else {
      // e[0].apply(this, args);
      e && e[0] && e[0].apply(this, args);
    }
  }

  addListener(type, fun) {
    const e = this.events[type];

    if (!e) {
      //如果从未注册过监听函数，则将函数放入数组存入对应的键名下
      this.events[type] = [fun];
    } else {
      //如果注册过，则直接放入
      e.push(fun);
    }
  }
}

const eventBus = new EventBus();

export default eventBus;
